//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[0,"CheckingG2Continuity",1,0],[0,"CyclicType",1,0],[0,"InterpolationType",1,0],[1,"MasterMaximum",0,"Expression",0],[1,"MasterMinimum",0,"Expression",0],[0,"MasterUnit",1,0],[0,"Name",1,0],[1,"SlaveMaximum",0,"Expression",0],[1,"SlaveMinimum",0,"Expression",0],[0,"SlaveUnit",1,0]],[[["element"],"FindElementIndex",{R_:{index:''}},1,0],[["part","element"],"AddElement",{},2,0],[["part","element","interPoints"],"AddElement1",{},3,0],[["index","part","element"],"EditElement",{},3,0],[["index"],"RemoveElementByIndex",{},1,0],[[],"ClearElements",{},0,0],[["segmentTableObject"],"SetSegmentTable",{},1,0],[["index"],"AskElementByIndex",{R_:{element:''}},1,0],[[],"AskElementsLength",{R_:{length:''}},0,0],[["segmentTableObject"],"SwitchSegmentTable",{},1,0]],[]];
SPLM.Mechatronics.CamProfileBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.CamProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.CamProfileBuilder.Element = class{
    constructor(id,segmentName,segmentType,curveType,slope,curvature,masterMin,masterMax,slaveMin,slaveMax,xn1,xn2,a0,a1,a2,a3,a4,a5,a6,amplitude,angularFrequency,phase,slopeEqualPrev,slopeEqualNext,curveEqualPrev,curveEqualNext,slope2,jerk,formulaType,lambdaValue,optimizeType,ynMin,ynMax){
        this.id=id;this.segmentName=segmentName;this.segmentType=segmentType;this.curveType=curveType;this.slope=slope;this.curvature=curvature;this.masterMin=masterMin;this.masterMax=masterMax;this.slaveMin=slaveMin;this.slaveMax=slaveMax;this.xn1=xn1;this.xn2=xn2;this.a0=a0;this.a1=a1;this.a2=a2;this.a3=a3;this.a4=a4;this.a5=a5;this.a6=a6;this.amplitude=amplitude;this.angularFrequency=angularFrequency;this.phase=phase;this.slopeEqualPrev=slopeEqualPrev;this.slopeEqualNext=slopeEqualNext;this.curveEqualPrev=curveEqualPrev;this.curveEqualNext=curveEqualNext;this.slope2=slope2;this.jerk=jerk;this.formulaType=formulaType;this.lambdaValue=lambdaValue;this.optimizeType=optimizeType;this.ynMin=ynMin;this.ynMax=ynMax;}
    get Id(){return this.id}
    set Id(val){this.id = val}
    get Segmentname(){return this.segmentName}
    set Segmentname(val){this.segmentName = val}
    get Segmenttype(){return this.segmentType}
    set Segmenttype(val){this.segmentType = val}
    get Curvetype(){return this.curveType}
    set Curvetype(val){this.curveType = val}
    get Slope(){return this.slope}
    set Slope(val){this.slope = val}
    get Curvature(){return this.curvature}
    set Curvature(val){this.curvature = val}
    get Mastermin(){return this.masterMin}
    set Mastermin(val){this.masterMin = val}
    get Mastermax(){return this.masterMax}
    set Mastermax(val){this.masterMax = val}
    get Slavemin(){return this.slaveMin}
    set Slavemin(val){this.slaveMin = val}
    get Slavemax(){return this.slaveMax}
    set Slavemax(val){this.slaveMax = val}
    get Xn1(){return this.xn1}
    set Xn1(val){this.xn1 = val}
    get Xn2(){return this.xn2}
    set Xn2(val){this.xn2 = val}
    get A0(){return this.a0}
    set A0(val){this.a0 = val}
    get A1(){return this.a1}
    set A1(val){this.a1 = val}
    get A2(){return this.a2}
    set A2(val){this.a2 = val}
    get A3(){return this.a3}
    set A3(val){this.a3 = val}
    get A4(){return this.a4}
    set A4(val){this.a4 = val}
    get A5(){return this.a5}
    set A5(val){this.a5 = val}
    get A6(){return this.a6}
    set A6(val){this.a6 = val}
    get Amplitude(){return this.amplitude}
    set Amplitude(val){this.amplitude = val}
    get Angularfrequency(){return this.angularFrequency}
    set Angularfrequency(val){this.angularFrequency = val}
    get Phase(){return this.phase}
    set Phase(val){this.phase = val}
    get Slopeequalprev(){return this.slopeEqualPrev}
    set Slopeequalprev(val){this.slopeEqualPrev = val}
    get Slopeequalnext(){return this.slopeEqualNext}
    set Slopeequalnext(val){this.slopeEqualNext = val}
    get Curveequalprev(){return this.curveEqualPrev}
    set Curveequalprev(val){this.curveEqualPrev = val}
    get Curveequalnext(){return this.curveEqualNext}
    set Curveequalnext(val){this.curveEqualNext = val}
    get Slope2(){return this.slope2}
    set Slope2(val){this.slope2 = val}
    get Jerk(){return this.jerk}
    set Jerk(val){this.jerk = val}
    get Formulatype(){return this.formulaType}
    set Formulatype(val){this.formulaType = val}
    get Lambdavalue(){return this.lambdaValue}
    set Lambdavalue(val){this.lambdaValue = val}
    get Optimizetype(){return this.optimizeType}
    set Optimizetype(val){this.optimizeType = val}
    get Ynmin(){return this.ynMin}
    set Ynmin(val){this.ynMin = val}
    get Ynmax(){return this.ynMax}
    set Ynmax(val){this.ynMax = val}
};

SPLM.Mechatronics.CamProfileBuilder.MasterValueUnit = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary", "Time" : "Time"});

SPLM.Mechatronics.CamProfileBuilder.ProfileCyclicType = Object.freeze({
    "RelativeCyclic" : "RelativeCyclic", "Cyclic" : "Cyclic", "NonCyclic" : "NonCyclic"});

SPLM.Mechatronics.CamProfileBuilder.SlaveValueUnit = Object.freeze({
    "LinearPosition" : "LinearPosition", "RotaryPosition" : "RotaryPosition", "LinearSpeed" : "LinearSpeed", "RotarySpeed" : "RotarySpeed"});

SPLM.Mechatronics.CamProfileBuilder.ProfileInterpolationType = Object.freeze({
    "CubicSpline" : "CubicSpline", "Linear" : "Linear", "BezierSpline" : "BezierSpline"});

export default SPLM;